var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('Snackbar'),_c('v-main',{staticClass:"pa-0",staticStyle:{"postion":"absolute","width":"100%","height":"100%"}},[_c('Navigation'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }